define(function (require) {
    "use strict";

    var LE = require("app");
    var ContentCannedModel = require("content-models/canned/ContentCannedModel");
    var RevisionedCollection = require("collections/RevisionedCollection");
    var ApiResources = require("assets/data/apiResources.json");
    var LocaleResolver = require("i18n/localeResolver");
    var CONST = require("const");
    var $ = require("jquery");
    var _ = require("underscore");

    var CannedCollection = {};
    var NAME = "CannedCollection";

   var FETCH_URL_PARAMETERS_SET = {
        fetchForTable: function(){
            var lang  = LocaleResolver.getLocale() + "," + LE.siteSettings.supportedLanguageSettings.getSupportedLanguageCodes().join(",");
            var select = "id,enabled,skillIds,categoriesIds,templateId,data(lang,title),hotkey,lobIds";

            return {
                lang  : lang,
                select: select
            };
        },
        fetchByIds:function() {
            var lang = LocaleResolver.getLocale() + "," + LE.siteSettings.supportedLanguageSettings.getSupportedLanguageCodes().join(",");
            var ids  = ""; // ids: "1,2,3,4" ...etc
            var select = "all";

            return {
                lang  : lang,
                ids: ids,
                select: select
            };
        }
    };

    LE.module("LEContent", function (LEContent, LE, Backbone, Marionette, $, _) {

        CannedCollection = RevisionedCollection.extend({
            model : ContentCannedModel,
            resource: ApiResources.AccountConfig.CannedMessages,
            name: NAME,
            url: function () {
                return RevisionedCollection.prototype.url.call(this);
            },
            fetch: function (option) {
                RevisionedCollection.prototype.fetch.call(this, _.extend({}, option ,{
                    data: $.param(this.getFetchURLParameters(option.fetchParameters || {state : "fetchForTable" }))
                }));
            },
            getFetchURLParameters: function (fetchParameters) {
                var fetchDataPermutationState = FETCH_URL_PARAMETERS_SET.fetchForTable();

                if(fetchParameters.state){
                    fetchDataPermutationState = _.extend({}, FETCH_URL_PARAMETERS_SET[fetchParameters.state](), _.omit((fetchParameters), "state"));
                }
                return fetchDataPermutationState;
            }
        });
    });
    CannedCollection.NAME = NAME;

    return CannedCollection;
});
